import GelButton from "./GelButton";

export default class GelHackButton extends P3.Button {
    constructor(states) {
        super(states);

        this.signals.focusIn = new P3.utils.MiniSignal();
        this.signals.focusOut = new P3.utils.MiniSignal();

        this.hitArea = new PIXI.Rectangle();

        this.refocusable = false;

        this._tabIndex = GelButton.TAB_INDEX_NONE;
        this._interactive = true;
        this._ariaLabel = "";

        const size = PIXI.utils.isMobile.any ? 64 : 70;
        const width = this._currentNormalTexture ? Math.max(size, this._currentNormalTexture.orig.width) : size;
        const height = this._currentNormalTexture ? Math.max(size, this._currentNormalTexture.orig.height) : size;

        this._htmlElement = $("<button type='button'>");
        this._htmlElement.scale = 1;
        this._htmlElement.css({
            "position"          : "absolute",
            "width"             : width + "px",
            //"width"             : this._currentNormalTexture.rotate === 2 ? height : width + "px",
            "height"            : height + "px",
            //"height"            : this._currentNormalTexture.rotate === 2 ? width : height + "px",
            "padding"           : 0 + "px",
            "border"            : "none",
            "background-color"  : "transparent",
            "cursor"            : "pointer"
        });

        if (!PIXI.utils.isMobile.any) {
            this._htmlElement.mousedown((event) => this.onMouseDown(event));
            this._htmlElement.mouseup((event) => this.onMouseUp(event));
            this._htmlElement.click((event) => this.onMouseClick(event));
            this._htmlElement.mouseover((event) => this.onMouseOver(event));
            this._htmlElement.mouseout((event) => this.onMouseOut(event));
        } else {
            this._htmlElement.on("touchstart", (event) => this.onMouseDown(event));
            this._htmlElement.on("touchend", (event) => this.onMouseUp(event));
        }

        this._htmlElement.focusin((event) => this.onFocusIn(event));
        this._htmlElement.focusout((event) => this.onFocusOut(event));

        const container = $("#" + P3.View.holder.id);
        container.append(this._htmlElement);

        this.on("added", this.resize, this);
    }

    /**
     * @param {PIXI.Texture} normal
     * @param {PIXI.Texture} [over]
     * @param {PIXI.Texture} [down]
     * @param {PIXI.Texture} [icon]
     */
    static create(normal, over, down, icon) {
        const states = new P3.ButtonStates(normal, over, down, icon);
        return new GelHackButton(states);
    }

    destroy() {
        this._htmlElement.remove();

        super.destroy();
    }

    resize() {
        const scale = P3.View.width / $(window).width();
        const inv = (1 / scale) * this.scale.x;
        const pos = this.toGlobal(new PIXI.Point());
        this._htmlElement.css({
            "left"              : Math.round(pos.x / scale),
            "top"               : Math.round(pos.y / scale),
            "margin-left"       : Math.round(-this._htmlElement.width() * 0.5) + "px",
            "margin-top"        : Math.round(-this._htmlElement.height() * 0.5) + "px",
            "transform"         : "scale(" + inv + ")",
            "-webkit-transform" : "scale(" + inv + ")",
            "-moz-transform"    : "scale(" + inv + ")",
            "-o-transform"      : "scale(" + inv + ")",
            "disabled"          : !this.interactive
        });
        this.visible ? this._htmlElement.show() : this._htmlElement.hide();
    }

    updateTransform() {
        super.updateTransform();
        this.resize();
    }

    onMouseDown(event) {
        super.onMouseDown(event);

        event.preventDefault();
        this._htmlElement.css("outline", "none");

        PIXI.utils.isMobile.any && this.onMouseClick(event);
    }

    onMouseUp(event) {
        super.onMouseUp(event);

        event.preventDefault();
    }

    onMouseClick(event) {
        super.onMouseClick(event);

        if (this.refocusable && document.activeElement === this._htmlElement[0]) {
            setTimeout(() => this._htmlElement.focus(), 0);
        }
    }

    onFocusIn(event) {
        this._htmlElement.css("outline", "2px solid #5E9ED6");
        this.onMouseOver(null);

        this.signals.focusIn.dispatch(this);
    }

    onFocusOut(event) {
        this._htmlElement.css("outline", "none");
        this.onMouseOut(null);

        this.signals.focusOut.dispatch(this);
    }

    get htmlElement() {
        return this._htmlElement;
    }

    get tabIndex() {
        return this._tabIndex;
    }

    set tabIndex(value) {
        this._tabIndex = value;
        this._htmlElement && this._htmlElement.attr("tabIndex", this._interactive ? value : GelButton.TAB_INDEX_NONE);
    }

    get interactive() {
        return this._interactive;
    }

    set interactive(value) {
        this._interactive = value;
        this._htmlElement && this._htmlElement.css("pointer-events", value ? "auto" : "none");

        this.tabIndex = this._tabIndex;
    }

    get ariaLabel() {
        return this._ariaLabel;
    }

    set ariaLabel(value) {
        this._ariaLabel = value;
        this._htmlElement.attr("ariaLabel", value);
    }
}